export const SLOT_DURATIONS = [30, 45, 60, 90];
